import { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import logo from "@/assets/logo.png";

const links = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/programs", label: "Programs" },
  { to: "/impact", label: "Impact" },
  { to: "/contact", label: "Contact" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <header className="sticky top-0 z-40 w-full border-b border-border/60 bg-background/85 backdrop-blur-md">
        <div className="container-wide flex h-24 items-center justify-between px-4 md:px-6">
          {/* Logo */}
          <Link to="/" onClick={() => setOpen(false)} className="flex-shrink-0">
            <img
              src={logo}
              alt="CRDO logo"
              className="h-16 w-16 md:h-20 md:w-20 object-contain"
            />
          </Link>

          <span className="hidden font-serif text-sm md:text-base font-semibold leading-tight text-primary md:block">
            Climate Resilient and Development Organization
          </span>

          <nav className="hidden items-center gap-3 md:flex">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                className={({ isActive }) =>
                  `px-3 py-2 text-base font-medium transition-colors ${
                    isActive ? "text-primary" : "text-muted-foreground hover:text-primary"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Button asChild variant="default" className="ml-3 bg-accent text-accent-foreground hover:bg-accent/90">
              <Link to="/donate">Donate</Link>
            </Button>
          </nav>

        <button className="md:hidden" onClick={() => setOpen(!open)} aria-label="Toggle menu">
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div className="border-t border-border md:hidden">
          <nav className="container-wide flex flex-col py-4">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `py-2.5 text-base font-medium ${isActive ? "text-primary" : "text-muted-foreground"}`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Button asChild className="mt-3 bg-accent text-accent-foreground hover:bg-accent/90">
              <Link to="/donate" onClick={() => setOpen(false)}>Donate</Link>
            </Button>
          </nav>
        </div>
      )}
    </header>
  </>
);
};

export default Navbar;
